import styled from "@emotion/styled";

export const ModuleLayoutContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 15px;
`;
